import type { PaymentMethod } from '../../../../dtos/own/types';

export type Props = {
  methods: PaymentMethod[];
};

export const PaymentLogos = ({ methods }: Props) => {
  if (!methods.length) {
    return null;
  }
  return (
    <>
      {methods.map(({ name, type, logoUrl }) => (
        <img key={type} src={logoUrl} alt={name} className={type} />
      ))}
    </>
  );
};
